import React from 'react';
import PropTypes from 'prop-types';

class RadioButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = { checked: (props.value === props.option) };
	}

	// Public API
	setValue = (value) => {
		this._update(value);
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }

	flag = (status) => {
		if (!status)
			this._input.classList.add('invalid-field');
		else
			this._input.classList.remove('invalid-field');
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_update = (value) => {
		const me = this;

		this.setState({ value }, function () {
			me.onDirt();

			// If managed by forms, trigger field change, then change
			if (this.props.managed)
				this.props.onFieldChange(this.props.option, this.props.name, function () { me.onChange(value); });
			else
				// If not, only trigger this comp change
				this.onChange(value);
		});
	}

	_handleChange = (e) => {
		this._update(e.target.checked);
	}

	// React lifecycle events
	componentWillReceiveProps(nextProps) {
		const checked = (nextProps.value === this.props.option);
		this.setState({ checked });
	}

	shouldComponentUpdate(nextProps, nextState) {
		const checked = this.state.checked;
		const nextChecked = (nextProps.value === this.props.option);
		return ((checked !== nextChecked) || nextProps.disabled !== this.props.disabled);
	}

	render() {
		const props = {
			name: this.props.name,
			checked: this.state.checked ? true : false,
			disabled: this.props.disabled,
			inline: this.props.inline,
			onChange: this._handleChange
		};

		return (
			<React.Fragment>
				<div className="radio">
					<label>
						<input type="radio" {...props} ref={(rd) => { this._input = rd }}  />
					{this.props.label}
					</label>
				</div>
			</React.Fragment>
		)
	}
}

export default RadioButton;

RadioButton.propTypes = {
	name: PropTypes.string.isRequired,
};

RadioButton.defaultProps = {
	formControl: true,
	managed: false
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/radioButton/RadioButton.js